import {Component, OnInit} from '@angular/core';
import {AppComponent} from './app.component';
import { AuthenticationService } from './_services/authentication.service';
import { Menu } from 'src/app/_models/usuario/menu';
import { Perfil } from './_models/usuario/perfil';
import { TranslateService } from '@ngx-translate/core';
import { BscobrancaTranslate } from './_services/bscobrancatranslate';

@Component({
    selector: 'app-menu',
    template: `
        <ul class="layout-menu">
            <li app-menuitem *ngFor="let item of model; let i = index;" [item]="item" [index]="i" [root]="true"></li>
        </ul>
    `
})
export class AppMenuComponent implements OnInit {

    model: any[];
    menus: Menu[];
    items: any[];
    perfil: Perfil;
    pesquisarTitulo: string;
    pesquisarClick: string;
    pesquisarArquivo: string;
    pesquisarSacado: string;
    adminstracao: string;
    manterEmpresa: string;
    manterAplicacao: string;
    manterPerfil: string;
    manterFuncionalidade: string;
    manterUsuario: string;
    manterBanco: string;
    manterCarteira: string;
    bscobranca: string;

    constructor(public app: AppComponent, private authenticationService: AuthenticationService,
                private bscobrancaTranslate: BscobrancaTranslate) {}

    ngOnInit() {
        this.menus = this.authenticationService.atualUserMenuValue;
        this.perfil = this.authenticationService.atualUserPerfilValue;
        this.items = [];


        this.pesquisarTitulo = this.bscobrancaTranslate.getText('menu.pesquisaTitulo');
        this.pesquisarClick = this.bscobrancaTranslate.getText('menu.pesquisarClick');
        this.pesquisarArquivo = this.bscobrancaTranslate.getText('menu.pesquisarArquivo');
        this.pesquisarSacado = this.bscobrancaTranslate.getText('menu.pesquisarSacado');
        this.adminstracao = this.bscobrancaTranslate.getText('menu.administracao');
        this.manterEmpresa = this.bscobrancaTranslate.getText('menu.manterEmpresa');
        this.manterAplicacao = this.bscobrancaTranslate.getText('menu.manterAplicacao');
        this.manterPerfil = this.bscobrancaTranslate.getText('menu.manterPerfil');
        this.manterFuncionalidade = this.bscobrancaTranslate.getText('menu.manterFuncionalidade');
        this.manterUsuario = this.bscobrancaTranslate.getText('menu.manterUsuario');
        this.manterBanco = this.bscobrancaTranslate.getText('menu.manterBanco');
        this.manterCarteira = this.bscobrancaTranslate.getText('menu.manterCarteira');
        this.bscobranca =  this.bscobrancaTranslate.getText('menu.bscobranca');

        if (this.perfil.nmePerfil === 'ADMTIVIT' || this.perfil.nmePerfil === 'MNGTIVIT' || this.perfil.nmePerfil === 'OPRTIVIT' )  {
            this.model = [
                        {
                            label: this.bscobranca, icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
                            items: [
                                {label: this.pesquisarTitulo, icon: 'pi pi-fw pi-pencil', routerLink: ['/titulo/pesquisatitulo']},
                                {label: this.pesquisarSacado, icon: 'pi pi-fw pi-pencil', routerLink: ['/sacado/sacado']},
                                {label: this.pesquisarArquivo, icon: 'pi pi-fw pi-pencil', routerLink: ['/arquivo/arquivo']},
                                {label: this.pesquisarClick, icon: 'pi pi-fw pi-pencil', routerLink: ['/titulo/pesquisaclick']},
                                {
                                    label:  this.adminstracao, icon: 'pi pi-fw pi-globe',
                                    items: [
                                        {label: this.manterEmpresa, icon: 'pi pi-fw pi-pencil',
                                            routerLink: '/administracao/empresa/empresa'},
                                        {label: this.manterAplicacao, icon: 'pi pi-fw pi-pencil', routerLink: '/administracao/aplicacao/aplicacao'},
                                        {label: this.manterPerfil, icon: 'pi pi-fw pi-pencil', routerLink: '/administracao/perfil/perfil'},
                                        {label: this.manterFuncionalidade, icon: 'pi pi-fw pi-pencil', routerLink: ['/administracao/funcionalidade/funcionalidade']},
                                        {label: this.manterUsuario, icon: 'pi pi-fw pi-pencil', routerLink: ['/usuario/usuario']},
                                        {label: this.manterBanco, icon: 'pi pi-fw pi-pencil', routerLink: ['/banco/banco']},
                                        {label: this.manterCarteira, icon: 'pi pi-fw pi-pencil', routerLink: ['/carteira/carteira']},
                                    ]
                                },
                            ]
                        },
                    ];
        }
        if (this.perfil.nmePerfil === 'ADMCEDENTE' || this.perfil.nmePerfil === 'MNGCEDENTE' || this.perfil.nmePerfil === 'OPRCEDENTE' )  {
            this.model = [
                {
                    label: this.bscobranca, icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
                    items: [
                                {label: this.pesquisarTitulo, icon: 'pi pi-fw pi-pencil', routerLink: ['/titulo/pesquisatitulo']},
                                {label: this.pesquisarSacado, icon: 'pi pi-fw pi-pencil', routerLink: ['/sacado/sacado']},
                                {label: this.pesquisarArquivo, icon: 'pi pi-fw pi-pencil', routerLink: ['/arquivo/arquivo']},
                                {label: this.pesquisarClick, icon: 'pi pi-fw pi-pencil', routerLink: ['/titulo/pesquisaclick']},
                        {
                            label:  this.adminstracao, icon: 'pi pi-fw pi-globe',
                            items: [
                                {label: this.manterUsuario, icon: 'pi pi-fw pi-pencil', routerLink: ['/usuario/usuario']},
                            ]
                        },
                    ]
                },
            ];
        }
        if (this.perfil.nmePerfil === 'CONSSACADO')  {
            this.model = [
                {
                    label: this.bscobranca, icon: 'pi pi-fw pi-briefcase', routerLink: ['/pages'],
                    items: [
                        {label: this.pesquisarSacado, icon: 'pi pi-fw pi-pencil', routerLink: ['/sacado/sacado']}
                    ]
                },
            ];
        }

    }
}
